module.exports = __webpack_public_path__ + "img/mtb_forest.9d4ce078.jpg";